import React from "react";
import { RxCrossCircled } from "react-icons/rx";
import Modal from "react-bootstrap/Modal";
import Genie from "../../../assets/accounts-section/Genie.png";
import Image from "react-bootstrap/Image";
import "../../DashboardNavbar/styles.css"; // Ensure styles are loaded

const MagicalWarningModal = (props) => {
    const { show, onHide } = props;

    return (
        <Modal
            className="parent-modal-dashboard"
            show={show}
            size="sm"
            onHide={onHide}
            centered
        >
            <Modal.Body className="word-check-modal-body">
                <div className="modal-body-main-container">
                    <div
                        className="cancel-btn-wrap"
                        onClick={onHide}
                    >
                        <RxCrossCircled className="cancel-btn" />
                    </div>
                    <div className="word-check-genie-container">
                        <div className="animated-image word-check-genie-wrap">
                            <Image
                                src={Genie}
                                fluid
                                className="blurred-shadow word-check-genie"
                            />
                        </div>
                    </div>

                    <div
                        className="dictionary-text"
                        style={{
                            marginTop: "80px",
                            textAlign: "center",
                            height: "auto",
                            maxHeight: "none",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            paddingTop: "20px"
                        }}
                    >
                        <p style={{ fontSize: "1.1rem", fontWeight: "600", lineHeight: "1.4" }}>
                            Are you sure you read everything?
                            <br />
                            If you skip now, you'll miss the best part of the story!
                        </p>
                        <p style={{ fontSize: "0.9rem", marginTop: "0px", fontStyle: "normal", color: "#666" }}>
                            (Click Next again to force a skip)
                        </p>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default MagicalWarningModal;
